import React from 'react';
export default function RageHelmetSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Horns */}
      <path d="M8 16 L2 2 L6 12" fill="#B71C1C" />
      <path d="M32 16 L38 2 L34 12" fill="#B71C1C" />
      {/* Horn ridges */}
      <path d="M7 14 L3 4" stroke="#D32F2F" strokeWidth="1" strokeLinecap="round" opacity="0.6" />
      <path d="M33 14 L37 4" stroke="#D32F2F" strokeWidth="1" strokeLinecap="round" opacity="0.6" />

      {/* Helmet dome */}
      <path d="M6 32 C6 16 10 10 20 10 C30 10 34 16 34 32 Z" fill="#37474F" />
      {/* Helmet highlight */}
      <path d="M10 30 C10 18 14 12 20 12 C26 12 30 18 30 30 Z" fill="#455A64" />

      {/* Center ridge / mohawk crest */}
      <path d="M18 10 L20 6 L22 10" fill="#546E7A" />
      <rect x="19" y="10" width="2" height="14" fill="#546E7A" />

      {/* Angry eye slits */}
      <path d="M10 22 L14 20 L18 22 L14 23 Z" fill="#0D0D0D" />
      <path d="M30 22 L26 20 L22 22 L26 23 Z" fill="#0D0D0D" />

      {/* Red glow inside eye slits */}
      <path d="M11 22 L14 20.5 L17 22 L14 22.5 Z" fill="#F44336" opacity="0.7" />
      <path d="M29 22 L26 20.5 L23 22 L26 22.5 Z" fill="#F44336" opacity="0.7" />

      {/* Mouth guard / jaw */}
      <rect x="10" y="28" width="20" height="6" rx="2" fill="#37474F" />
      {/* Jaw vents */}
      <rect x="13" y="29" width="2" height="4" rx="0.5" fill="#263238" />
      <rect x="17" y="29" width="2" height="4" rx="0.5" fill="#263238" />
      <rect x="21" y="29" width="2" height="4" rx="0.5" fill="#263238" />
      <rect x="25" y="29" width="2" height="4" rx="0.5" fill="#263238" />

      {/* Red accent lines */}
      <path d="M10 26 L30 26" stroke="#D32F2F" strokeWidth="1.5" />
      <path d="M6 32 L34 32" stroke="#D32F2F" strokeWidth="1" />

      {/* Rivet details */}
      <circle cx="10" cy="26" r="1" fill="#B0BEC5" />
      <circle cx="30" cy="26" r="1" fill="#B0BEC5" />

      {/* Eye glow pulse */}
      <ellipse cx="14" cy="21.5" rx="2" ry="1" fill="#FF1744" opacity="0.2">
        <animate attributeName="opacity" values="0.1;0.3;0.1" dur="1.5s" repeatCount="indefinite" />
      </ellipse>
      <ellipse cx="26" cy="21.5" rx="2" ry="1" fill="#FF1744" opacity="0.2">
        <animate attributeName="opacity" values="0.1;0.3;0.1" dur="1.5s" repeatCount="indefinite" />
      </ellipse>
    </svg>
  );
}
